import { getEnumObject } from '../utilities.js';

export const integrationActions = {
  ABSHER_SEND_OTP: 'ABSHER_SEND_OTP',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  ACCOUNT_BALANCE: 'ACCOUNT_BALANCE',
  ADMIN_MERCHANTS_BY_CR: 'admin.merchants.by.cr',
  ADMIN_VERIFIED_ACCOUNTS_CREATE: 'admin.verified_accounts.create',
  AGGREGATE_PAYMENTS_CONTROLLER: 'AggregatePaymentsController',
  APPROVE_CLIENT: 'APPROVE_CLIENT',
  ASSIGN_TERMINAL: 'ASSIGN_TERMINAL',
  BUSINESS_NAME_CHANGE_APPROVED: 'BUSINESS_NAME_CHANGE_APPROVED',
  CANCEL_TRANSACTION: 'CANCEL_TRANSACTION',
  CASHIER_APP_TERMINALS_VALIDATE: 'cashier_app.terminals_validate',
  CONSOLE_MERCHANT_ENABLED: 'console.merchant_enabled',
  CONSOLE_MERCHANT_VERIFIED: 'console.merchant_verified',
  CONSOLE_REPORTS_PAYMENTS_BY: 'console.reports.payments_by',
  CREATE_SUPPLY_INSTALLMENTS: 'CREATE_SUPPLY_INSTALLMENTS',
  CREATE_VERIFIED_ACCOUNT_CONTROLLER: 'CreateVerifiedAccountController',
  FOODICS_CAPITAL_WEBHOOK: 'FOODICS_CAPITAL_WEBHOOK',
  FOODICS_USER_LOGIN_OTP: 'FOODICS_USER_LOGIN_OTP',
  FOODICS_USER_MOBILE_VERIFY_OTP: 'FOODICS_USER_MOBILE_VERIFY_OTP',
  FOODICS_CAPITAL_ADJUSTMENTS_INDEX: 'foodics-capital.adjustments.index',
  FOODICS_CAPITAL_ADJUSTMENTS_SHOW: 'foodics-capital.adjustments.show',
  FOODICS_CAPITAL_ADJUSTMENTS_STORE: 'foodics-capital.adjustments.store',
  FOODICS_CAPITAL_LOANS_FUND: 'foodics-capital.loans.fund',
  GENERIC_PAYMENT_RETURNED_NOTIFICATION_SENT: 'GENERIC_PAYMENT_RETURNED_NOTIFCATION_SENT',
  GET_PAYMENT_STATUS: 'GET_PAYMENT_STATUS',
  GET_RMS_BRANCH: 'GET_RMS_BRANCH',
  GET_TRANSACTIONS: 'GET_TRANSACTIONS',
  IAM_FOODOICS_USER_CREATE: 'IAM_FOODOICS_USER_CREATE',
  IAM_FOODOICS_USERS_AUTHORITIES: 'IAM_FOODOICS_USERS_AUTHORITIES',
  IAM_FOODOICS_USERS_LIST: 'IAM_FOODOICS_USERS_LIST',
  INITIATE_RECONCILIATION: 'INITIATE_RECONCILIATION',
  INITIATE_TRANSACTION: 'INITIATE_TRANSACTION',
  INTERSOFT_SUPPORT: 'INTERSOFT_SUPPORT',
  LIMITS_CONTROLLER: 'LimitsController',
  LOAN_INSTALLMENT: 'LOAN_INSTALLMENT',
  LOAN_PAYMENT: 'LOAN_PAYMENT',
  LOYALTY_DEMO: 'LOYALTY_DEMO',
  MERCHANT_COMMERCIAL_REGISTRATION_EXPIRY: 'MERCHANT_COMMERCIAL_REGISTRATION_EXPIRY',
  MERCHANT_USER_CALL_CENTER_VERIFICATION_OTP_REQUESTED:
    'MERCHANT_USER_CALL_CENTER_VERIFICATION_OTP_REQUESTED',
  MERCHANT_USER_LOGIN_OTP: 'MERCHANT_USER_LOGIN_OTP',
  MERCHANT_USER_MOBILE_VERIFY_OTP: 'MERCHANT_USER_MOBILE_VERIFY_OTP',
  MERCHANT_ENABLED_CONTROLLER: 'MerchantEnabledController',
  MERCHANTS_BY_CR_CONTROLLER: 'MerchantsByCRController',
  MERCHANT_VERIFIED_CONTROLLER: 'MerchantVerifiedController',
  MT940_LIST: 'MT940_LIST',
  MT940_STATEMENT: 'MT940_STATEMENT',
  MT942_STATEMENT: 'MT942_STATEMENT',
  NAFATH_CHECK_STATUS: 'NAFATH_CHECK_STATUS',
  NAFATH_SEND_REQUEST: 'NAFATH_SEND_REQUEST',
  NAFATH_WEBHOOK_CONTROLLER_CALLBACK: 'NafathWebhookController@callback',
  NEAR_PAY_GET_TOKEN: 'near_pay.getToken',
  NEARPAY_CREATE_RECONCILIATION: 'NEARPAY_CREATE_RECONCILIATION',
  NEARPAY_FIND_RECONCILIATION: 'NEARPAY_FIND_RECONCILIATION',
  NEARPAY_FIND_TRANSACTION: 'NEARPAY_FIND_TRANSACTION',
  NEARPAY_LIST_RECONCILIATIONS: 'NEARPAY_LIST_RECONCILIATIONS',
  NEARPAY_LIST_TRANSACTIONS: 'NEARPAY_LIST_TRANSACTIONS',
  ONBOARD_REQUEST_APPROVED: 'ONBOARD_REQUEST_APPROVED',
  ONBOARD_REQUEST_REJECTED: 'ONBOARD_REQUEST_REJECTED',
  ORDER_DETAILS: 'ORDER_DETAILS',
  PAYMENTS_REPORT: 'PAYMENTS_REPORT',
  PENDING_CLIENT: 'PENDING_CLIENT',
  PICO_AUTH: 'pico.auth',
  PICO_TERMINALS_PING: 'pico.terminals.ping',
  PICO_WS_AUTH: 'pico.ws.auth',
  POST_MERCHANT: 'POST_MERCHANT',
  POST_TERMINAL: 'POST_TERMINAL',
  QUERY_SCREENED_REFERENCE: 'QUERY_SCREENED_REFERENCE',
  RECONCILIATION_STATUS: 'RECONCILIATION_STATUS',
  REPORT_OVERVIEW: 'REPORT_OVERVIEW',
  REQUEST_LOAN: 'REQUEST_LOAN',
  RISK_SCORE_ORGANIZATION: 'RISK_SCORE_ORGANIZATION',
  SCREEN_INDIVIDUAL: 'SCREEN_INDIVIDUAL',
  SCREEN_ORGANIZATION: 'SCREEN_ORGANIZATION',
  SUBMIT_ORDER: 'SUBMIT_ORDER',
  SUBMIT_RECONCILIATION: 'SUBMIT_RECONCILIATION',
  SUBMIT_RECONCILIATION_JSON: 'SUBMIT_RECONCILIATION_JSON',
  SUBMIT_RECONCILIATION_XML: 'SUBMIT_RECONCILIATION_XML',
  SUBMIT_STANDARD_INVOICE: 'SUBMIT_STANDARD_INVOICE',
  SUBMIT_TRANSACTIONS_JSON: 'SUBMIT_TRANSACTIONS_JSON',
  SUBMIT_TRANSACTIONS_XML: 'SUBMIT_TRANSACTIONS_XML',
  SUBMIT_XML_TRANSACTION: 'SUBMIT_XML_TRANSACTION',
  SUBMIT_TRANSACTION_CONTROLLER: 'SubmitTransactionController',
  SUBSCRIBE_TO_WEBHOOK: 'SUBSCRIBE_TO_WEBHOOK',
  SUPPLY_LIMITS: 'SUPPLY_LIMITS',
  SUPPLY_LIMITS_ALIAS: 'supply.limits',
  SALESFORCE_SYNC_TERMINAL: 'SALESFORCE_SYNC_TERMINAL',
  SALESFORCE_OAUTH: 'SALESFORCE_OAUTH',
  TERMINAL_DEVICE_CONNECTED_CONTROLLER: 'TerminalDeviceConnectedController',
  TMS_INTERSOFT_CHANGE_APPROVED: 'TMS_INTERSOFT_CHANGE_APPROVED',
  TRANSACTION_STATUS: 'TRANSACTION_STATUS',
  TRANSACTIONS_AGGREGATE_REPORT: 'TRANSACTIONS_AGGREGATE_REPORT',
  TRANSACTIONS_REPORT: 'TRANSACTIONS_REPORT',
  TRANSFER_PAYMENT: 'TRANSFER_PAYMENT',
  UPDATE_WEBHOOK_CLIENT: 'UPDATE_WEBHOOK_CLIENT',
  VALIDATE_IBAN: 'VALIDATE_IBAN',
  VALIDATE_TERMINAL_CONTROLLER: 'ValidateTerminalController',
  WATHQ_BASIC_INFO: 'WATHQ_BASIC_INFO',
  WATHQ_FULL_INFO: 'WATHQ_FULL_INFO',
  WATHQ_LIST_RELATED_CRS: 'WATHQ_LIST_RELATED_CRS',
  WATHQ_VALIDATE_CR: 'WATHQ_VALIDATE_CR',
  WEBHOOK_CONTROLLER: 'WebhookController',
  WEBHOOKS_CHECKOUT: 'webhooks.checkout',
  WEBHOOKS_D360: 'webhooks.d360',
  WEBHOOKS_FOCAL: 'webhooks.focal',
  WEBHOOKS_NAFATH: 'webhooks.nafath',
  WEBHOOKS_NEAR_PAY_POST_TRANSACTION: 'webhooks.near_pay.post_transaction',
  WEBHOOKS_NEAR_PAY_TERMINAL_DEVICE_CONNECTED: 'webhooks.near_pay.terminal_device_connected',
  WEBHOOKS_NEAR_PAY_TERMINAL_DEVICE_DISCONNECTED: 'webhooks.near_pay.terminal_device_disconnected',
  WHO_AM_I: 'WHO_AM_I',
  YAKEEN_VERIFY_PHONE: 'YAKEEN_VERIFY_PHONE',
};

export default getEnumObject(integrationActions);
